export const MGMySubscriptionDetailCardType = Object.freeze(
    {
        SAVING: "SAVING",
        PROTECTION: "PROTECTION",
        SAVING_PLUS_PROTECTION: "SAVING_PLUS_PROTECTION"
    }
); 